// TODO(backend): wire this to a real submission endpoint (Vercel serverless
// function, Formspree, Apps Script webhook, etc.). For now we just log signups
// to the console so they're visible during testing.

export type Concern = 'phishing' | 'smishing' | 'vishing' | 'all';

export interface WaitlistEntry {
  fullName: string;
  email: string;
  company?: string;
  role?: string;
  concern: Concern;
  consent: boolean;
  awarenessScore?: number;
  awarenessTier?: string;
  submittedAt: string;
}

export function saveWaitlistEntry(entry: Omit<WaitlistEntry, 'submittedAt'>): WaitlistEntry {
  const stored: WaitlistEntry = {
    ...entry,
    submittedAt: new Date().toISOString(),
  };
  // eslint-disable-next-line no-console
  console.info('[Driscop waitlist] new signup (TODO: wire backend)', stored);
  return stored;
}
